import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import NumberFormat from "react-number-format";
import DateFnsUtils from '@date-io/date-fns';

import Select from "react-select";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Api from "../../../libraries/api";
import {history} from "../../../shared/configure-store";

import BrokerTab from './components/BrokerTab';
import AdjusterTab from './components/AdjusterTab';
import ShipownerTab from './components/ShipownerTab';
import UnderwriterTab from './components/UnderwriterTab';

require('dotenv').config();

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}


const styles = theme => ({
  root: {
    display: 'flex',
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minWidth: '150px',
  },
  tabRoot: {
    alignItems: 'flex-start',
  },
  tabWrapper: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    textAlign: 'left',
  },
  tabContent: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  breadcrumb: {
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
});

class OSClients extends Component {
    _isMounted = false;

    constructor(props) {

        super(props);

        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},

            orderBy: '',
            sortedBy: '',
            searchBy: '',

            roles: [],
            clients: [],
            showDialog: false,
            idDelete: '',
            currDelete: '',

            name: '',
            detail: '',
            filterYear: new Date().getFullYear(),
            filterClient: '',

            rows: [],
            broker: [],
            adjuster: [],
            shipowner: [],
            underwriter: [],
            totalCase: 0,
            totalOnprogress: 0,
            totalFollowup: 0,
            pendingIdr: 0,
            pendingUsd: 0,
            total: 0,
            perPage: 10,
            currentPage: 1,
            currentPageTable: 0,
            client_id: '',

            isEdit: false,
            isDelete: false,
            isCreate: false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

        document.title = 'Abadi - OS Client';


        this.__fetchData(false);

        Api.get('/clients?limit=0').then(resp => {

            if (resp.data) {

                let data = resp.data.map(o=>{
                    return {
                        label: o.name,
                        value: o.name,
                    }
                });

                this.setState({
                    clients: data,
                })

            }

        }).catch(err => {
            console.log(err);
        });


    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    __fetchData = () => {
        this._isMounted = true;
        let route = `/reports/os-clients?year=${this.state.filterYear}`;
        if (this.state.client_id) route = `/reports/os-clients?name=${this.state.client_id}&year=${this.state.filterYear}`;

        Api.get(route).then(resp => {
            if (this._isMounted) {
                if (resp.data) {
                    this.setState({
                        data: resp.data,
                        broker: resp.data.broker,
                        adjuster: resp.data.adjuster,
                        shipowner: resp.data.shipowner,
                        underwriter: resp.data.underwriter,
                        totalCase: resp.data.total_all.total_case,
                        totalOnprogress: resp.data.total_all.total_onprogress,
                        totalFollowup: resp.data.total_all.total_followup,
                        pendingIdr: resp.data.total_all.pending_idr,
                        pendingUsd: resp.data.total_all.pending_usd,
                        loading: false
                    });
                }
            }
        });
    };

    handleSearch = () => {
        this.__fetchData(false);
    };
    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.__fetchData(false);
        }
    };

    handleSort = (val) => {

        let sortedBy = this.state.sortedBy;

        if(val !== this.state.orderBy){
            sortedBy = 'asc';
        }else{
            if(sortedBy && sortedBy === 'asc' ){
                sortedBy = 'desc';
            }else{
                sortedBy = 'asc';
            }
        }

        this.setState({
            orderBy: val,
            sortedBy: sortedBy,
            loading: true
        }, () => {
            this.__fetchData(false);
        });
    };

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        })

    };

    handleOpen = (row) => {
        this.setState({
            showDialog :true,
            idDelete: row.id,
            currDelete: row.name,
        })
    };

    handleClose = () => {
        this.setState({
            showDialog :false,
        })
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            rows: [],
            currentPage:newPage,
            currentPageTable:newPage,
            loading: true,
        }, () => {
            this.__fetchData(true);
        });
    };

    handleGo  = (link) => {

        history.push(link);
    };

    handleChangeClient = (e) => {
    this.setState({
        filterClient: e,
        client_id: e ? e.value : '',
    }, () => {
        this.__fetchData(false);
    });
};

    handleChangeYear = (year) => {
        this.setState({ year: moment(year).format('YYYY') }, () => {
            this.__fetchData();
        });
    } 

    render() {
        const minYear = 2002;
        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">OS Clients List</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">OS Clients</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper">
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='row'>
                                    <div className='col-md'>
                                        <div className="card-info green">
                                            <label className="label-grey">Total <br />Case</label>
                                            <p className="number">{this.state.totalCase && this.state.totalCase}</p>
                                        </div>
                                    </div>
                                    <div className='col-md'>
                                        <div className="card-info green">
                                            <label className="label-grey">On Progress <br />Case</label>
                                            <p className="number">{this.state.totalOnprogress && this.state.totalOnprogress}</p>
                                        </div>
                                    </div>
                                    <div className='col-md'>
                                        <div className="card-info green">
                                            <label className="label-grey">Follow Up <br />Case</label>
                                            <p className="number">{this.state.totalFollowup && this.state.totalFollowup}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='row'>
                                    <div className='col-md'>
                                        <div className="card-info yellow">
                                            <label className="label-grey">Total Not Paid <br /> Invoice IDR</label>
                                            <p className="number">
                                                <NumberFormat thousandSeparator={true} decimalScale={2} value={this.state.pendingIdr && this.state.pendingIdr} displayType={'text'} renderText={value => <span>{value}</span>}/>
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-md'>
                                        <div className="card-info yellow">
                                            <label className="label-grey">Total Not Paid <br /> Invoice USD</label>
                                            <p className="number">
                                                <NumberFormat thousandSeparator={true} decimalScale={2} value={this.state.pendingUsd && this.state.pendingUsd} displayType={'text'} renderText={value => <span>{value}</span>}/>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-2'>
                                <div className='form-group'>
                                    <label>Year</label>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DatePicker
                                            views={['year']}
                                            value={moment(this.state.filterYear, 'YYYY').toDate()}
                                            onChange={this.handleChangeYear}
                                            format="yyyy"
                                            cancelLabel='BATAL'
                                            inputVariant='outlined'
                                            minDate={moment(minYear, 'YYYY')}
                                            maxDate={moment().endOf('year')}
                                            autoOk
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='form-group'>
                                    <label>Client</label>
                                    <Select 
                                        options = {this.state.clients}
                                        onChange={(e) => this.handleChangeClient(e,'filterClient')}
                                        value={this.state.filterClient}
                                        placeholder="Select Client"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                height: '46px',
                                            }),
                                        }}
                                        isClearable
                                    />
                                    <div className='text-danger'>{this.state.errors.filterClient}</div>
                                </div>
                            </div>
                        </div>

                        <div className={this.props.classes.root}>
                            {/* Vertical Tabs */}
                            <Tabs
                                value={this.state.tabIndex || 0}
                                onChange={(e, newValue) => this.setState({ tabIndex: newValue })}
                                orientation="vertical"
                                variant="scrollable"
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{ root: this.props.classes.tabs }}
                            >
                                <Tab label="BROKER" {...a11yProps(0)} classes={{ root: this.props.classes.tabRoot, wrapper: this.props.classes.tabWrapper }} />
                                <Tab label="ADJUSTER" {...a11yProps(1)} classes={{ root: this.props.classes.tabRoot, wrapper: this.props.classes.tabWrapper }} />
                                <Tab label="SHIPOWNER" {...a11yProps(2)} classes={{ root: this.props.classes.tabRoot, wrapper: this.props.classes.tabWrapper }} />
                                <Tab label="UNDERWRITER" {...a11yProps(3)} classes={{ root: this.props.classes.tabRoot, wrapper: this.props.classes.tabWrapper }} />
                            </Tabs>
                            {/* Tab Panels */}
                            <div style={{ width: '100%' }}>
                                { (this.state.tabIndex || 0) === 0 && <BrokerTab loading={this.state.loading} data={this.state.broker} /> }
                                { (this.state.tabIndex || 0) === 1 && <AdjusterTab loading={this.state.loading} data={this.state.adjuster} /> }
                                { (this.state.tabIndex || 0) === 2 && <ShipownerTab loading={this.state.loading} data={this.state.shipowner} /> }
                                { (this.state.tabIndex || 0) === 3 && <UnderwriterTab loading={this.state.loading} data={this.state.underwriter} /> }
                            </div>
                        </div>
                    </div>
                </div>



                <ToastContainer autoClose={3000} />

            </div>
        )
    }
}

export default withStyles(styles)(OSClients);
